import classNames from 'classnames'

import BbUploadButton from '../BbUploadButton'
import Img from 'components/common/Img'
import './style.styl'
import { useContext } from 'react'
import { UploadContext } from 'pages/credit/BbOurocard/contexts/uploadContext'
import { TakePhotoButton } from '../../TakePhotoButton'
import { Conditional } from 'iq-blueberry'
import { TakePhotoButtonOptimized } from '../../TakePhotoButton/TakePhotoButtonOptimized'

const UploadBlock = ({
  title,
  desc,
  instruction,
  adviceText,
  imgSrc,
  reviewImageText,
  hasUploadError,
  buttonContinue,
  handleStepAfterUpload,
  readyForNextStep,
  goToNextStep,
  optimized = false,
}) => {
  const { uploadedFilesState } = useContext(UploadContext)

  const UploadButton = () => (
    <Conditional
      condition={optimized}
      renderIf={
        <TakePhotoButtonOptimized
          showMask
          maskType="user"
          fileReference="user_photo"
          side="frontUser"
          reviewImageText={reviewImageText}
          filesReferencesState={uploadedFilesState}
          asUploadError={hasUploadError}
          handleStepAfterUpload={handleStepAfterUpload}
          readyForNextStep={readyForNextStep}
          goToNextStep={goToNextStep}
        />
      }
      renderElse={
        <TakePhotoButton
          showMask
          maskType="user"
          fileReference="user_photo"
          side="frontUser"
          reviewImageText={reviewImageText}
          filesReferencesState={uploadedFilesState}
          hasUploadError={hasUploadError}
          handleStepAfterUpload={handleStepAfterUpload}
        />
      }
    />
  )

  return (
    <div className="upload-block">
      <div className="upload-block__holder">
        <div className="upload-block__top">
          <div className="upload-block__text">
            <h2 className="upload-block__title">{title}</h2>
            <div className="upload-block__desc">{desc}</div>
            <p className="upload-block__instruction">
              <strong>{instruction}</strong>
            </p>
          </div>
          {imgSrc && (
            <div className="upload-block__image-holder">
              <Img src={imgSrc} />
            </div>
          )}
        </div>
        <div className="upload-block__desk-button-holder">
          <UploadButton />
        </div>
        <div>{buttonContinue}</div>
        {adviceText && (
          <div className="upload-block__advice">
            <Img
              src="images/bb/identity-proof/shield-icon.svg"
              alt="Ícone de um escudo na cor cinza"
            />
            {adviceText}
          </div>
        )}
      </div>
      <div className="upload-block__mobile-actions">
        <p>
          <strong>Enviar foto selfie *</strong>
        </p>
        <div className="upload-block__mobile-actions__buttons">
          <UploadButton />
        </div>
      </div>
    </div>
  )
}

export default UploadBlock
